
import { CSSProperties, MouseEvent, useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { SideBarMenuEntity, SidebarSubMenuEntity } from '../interface';
import { AssignedModuleData, UserInfoEntity } from '../interface/sign-in';
import { useRedRibbon } from '../store/redRibbon.store';
import { allFeaturedModules } from '../utils/constants';
import { ActionEntityEnum, StorageKeyEnum } from '../utils/enum';
import { IsNullOrEmptyArray, IsStringNullEmptyOrUndefined } from '../utils/null-check';

declare var $: any;


function SideBar() {
  const navigate = useNavigate();
  const location = useLocation();

  const { setProductionPlannedStatus } = useRedRibbon()

  const handleNavigate = () => {
    const hostname = window.location.hostname;
    if (hostname === 'jb-glass-qa.jarvistechnolabs.com' || hostname === 'localhost') {
      return "/analytics-with-scheduler"
    }
    return "/analytics"
  }
  const allMenus: SideBarMenuEntity[] = [
    {
      icon: "icon-dashboard menu-icon",
      moduleName: allFeaturedModules.dashboard,
      isHoverOpen: false,
      url: "/dashboard",
      subMenu: [],
    },
    {
      icon: "fa fa-bullhorn fa-2x menu-icon",
      moduleName: allFeaturedModules.campaign,
      isHoverOpen: false,
      url: "",
      subMenu: [
        {
          moduleName: "Manage Campaign",
          url: "/campaign",
        },
        {
          moduleName: "WhatsApp History",
          url: "/whatsapp-history",
        },
        {
          moduleName: "Email History",
          url: "/email-history",
        },
      ],
    },
    {
      icon: "fa fa-users menu-icon fs-5",
      moduleName: allFeaturedModules.socials,
      isHoverOpen: false,
      url: "",
      subMenu: [
        {
          moduleName: "State to User Mapping",
          url: "/socials/state-to-user-mapping",
        },
        {
          moduleName: "Social Leads",
          url: "/socials/leads",
        },
      ],
    },
    {
      icon: "icon-task-square menu-icon",
      moduleName: allFeaturedModules.ProductionPlanning,
      isHoverOpen: false,
      url: "",
      subMenu: [
        {
          moduleName: "Draft WOs",
          url: "/draft-work-order-list",
        },
        {
          moduleName: "Accountant WOs",
          url: "/accountant-work-order-list",
        },
        {
          moduleName: "Production Plan WOs",
          url: "/production-work-order-list",
        },
        {
          moduleName: "Production Team WOs",
          url: "/production-team-work-order",
        },
        {
          moduleName: "Saleperson WOs",
          url: "/sales-person-work-order",
        },
        {
          moduleName: "Dispatch Manager WOs",
          url: "/dispatch-manager-work-order",
        },
        {
          moduleName: "Work Orders List",
          url: "/work-order-details",
        },
        {
          moduleName: "DM BIC Data",
          url: "/project-manager-bic-data",
        },
        {
          moduleName: "Master DA",
          url: "/master-delivery-advice",
        },
        {
          moduleName: "WO Tracker",
          url: "/work-order-tracker",
        },
        {
          moduleName: "Location Tracker",
          url: "/location-tracker",
        },
        {
          moduleName: "Project Tracker",
          url: "/project-tracker",
        },
        {
          moduleName: "Paint Jobs",
          url: "/paint-job-list",
        },
        {
          moduleName: "RM Projection",
          url: "/rm-projection",
        },
      ],
    },
    {
      icon: "user-shield-icon",
      moduleName: allFeaturedModules.TrustSeal,
      isHoverOpen: false,
      url: "/view-trust-seal",
      subMenu: [],
    },
    {
      icon: "icon-newOrder menu-icon",
      moduleName: allFeaturedModules.wallOrders,
      isHoverOpen: false,
      url: "/wall-orders",
      subMenu: [],
    },
    {
      icon: "fa fa-flag-o fa-2x text-danger",
      moduleName: allFeaturedModules.redFlag,
      isHoverOpen: false,
      url: "/red-flag",
      subMenu: [],
    },
    {
      icon: "icon-clipboard-tick menu-icon",
      moduleName: allFeaturedModules.directory,
      isHoverOpen: false,
      url: "",
      subMenu: [
        {
          moduleName: "Architect Details",
          url: "/architect-details",
        },
        {
          moduleName: "Directory Master",
          url: "/directory-master",
        },
        {
          moduleName: "India Design",
          url: "/india-design-event",
        },
        {
          moduleName: "ID Visitors",
          url: "/ID-visitors",
        },
        {
          moduleName: "ID Invitations",
          url: "/ID-invitations",
        },
        {
          moduleName: "Meetings",
          url: "/meetings",
        },
        {
          moduleName: "Leads",
          url: "/leads",
        },
        {
          moduleName: "B2B",
          url: "/b2b",
        },
      ],
    },
    {
      icon: "icon-gallery menu-icon",
      moduleName: allFeaturedModules.JBLibrary,
      isHoverOpen: false,
      url: "",
      subMenu: [
        {
          moduleName: "Albums",
          url: "/jb-library/albums",
        },
        // {
        //   moduleName: "Photos",
        //   url: "/photos",
        // },
        {
          moduleName: "Tags",
          url: "/jb-library/tags",
        },
        {
          moduleName: "Users Tracking",
          url: "/jb-library/users-tracking",
        },
        {
          moduleName: "Online Users",
          url: "/jb-library/online-users",
        },
      ],
    },
    {
      icon: "icon-setting menu-icon",
      moduleName: allFeaturedModules.settings,
      isHoverOpen: false,
      url: "/settings",
      subMenu: [],
    },
    {
      icon: "fa fa-bullseye fa-2x vision-icon",
      moduleName: allFeaturedModules.Vision,
      isHoverOpen: false,
      url: "/vision",
      subMenu: [],
    },
    {
      icon: "icon-download menu-icon",
      moduleName: allFeaturedModules.downloads,
      isHoverOpen: false,
      url: "/downloads",
      subMenu: [],
    },
    {
      icon: "icon-analytics menu-icon",
      moduleName: allFeaturedModules.analytics,
      isHoverOpen: false,
      url: handleNavigate(),
      subMenu: [
        // { moduleName: allFeaturedModules.reports, url: "/analytics/reports" },
        // { moduleName: allFeaturedModules.orderReport, url: "/analytics/order-report" },
      ],
    },
    {
      icon: "fa fa-exclamation-triangle menu-icon",
      moduleName: allFeaturedModules.observationErrors,
      isHoverOpen: false,
      url: "/observation-errors",
      subMenu: [],
    },
    {
      icon: "fa fa-book menu-icon",
      moduleName: allFeaturedModules.goProAssetsModule,
      isHoverOpen: false,
      url: "/education-assets-module",
      subMenu: [],
    },
    {
      icon: "icon-handles menu-icon",
      moduleName: "Role Management",
      isHoverOpen: false,
      url: "/role-management",
      subMenu: [],
    },
    // {
    //     icon: "icon-newOrder menu-icon",
    //     moduleName: allFeaturedModules.glassOrders,
    //     isHoverOpen: false,
    //     url: "/glass-orders",
    //     subMenu: []
    // },
    {
      icon: "icon-transaction menu-icon",
      moduleName: allFeaturedModules.transactions,
      isHoverOpen: false,
      url: "",
      subMenu: [
        {
          moduleName: "Make Payment",
          url: "/transactions/payment",
        },
        {
          moduleName: "Payment History",
          url: "/transactions/payment-history",
        },
        {
          moduleName: "Settlements",
          url: "/transactions/settlements",
        },
        {
          moduleName: "Draft Transactions",
          url: "/transactions/draft-transactions",
        },
        {
          moduleName: "Refund Payment History",
          url: "/transactions/refund-payment-history",
        },
        {
          moduleName: "Invoices",
          url: "/transactions/invoices",
        },
        {
          moduleName: "Credit Note",
          url: "/transactions/credit-note",
        },
      ],
    },
    {
      icon: "fa fa-tasks menu-icon",
      moduleName: allFeaturedModules.TBSTracker,
      isHoverOpen: false,
      url: "",
      subMenu: [
        {
          moduleName: "Send For TBS",
          url: "/TBS/send-for-tbs",
        },
        {
          moduleName: "TBS Store",
          url: "/TBS/tbs-store",
        },
      ],
    },
    // {
    //   icon: "icon-order-due menu-icon",
    //   moduleName: allFeaturedModules.orderDue,
    //   isHoverOpen: false,
    //   url: "/order-due",
    //   subMenu: [],
    // },
  ];

  const [sidebarMenus, setSidebarMenus] = useState<SideBarMenuEntity[] | []>(
    []
  );

  useEffect(() => {
    const userStr: string | null = localStorage.getItem(
      StorageKeyEnum.JB_GLASS_USER_INFO
    );

    if (userStr && !IsStringNullEmptyOrUndefined(userStr)) {
      const userInfo: UserInfoEntity = JSON.parse(userStr);
      const modules: AssignedModuleData[] = userInfo.assignedModule;

      const listActionModules = modules.filter(
        (e) =>
          e.action === ActionEntityEnum.LIST &&
          IsStringNullEmptyOrUndefined(e.parentId)
      );
      const listActionSubModules = modules.filter(
        (e) =>
          e.action === ActionEntityEnum.LIST &&
          !IsStringNullEmptyOrUndefined(e.parentId)
      );

      let authorizedMenus: SideBarMenuEntity[] = [];

      for (const list of listActionModules) {
        const index: number = allMenus.findIndex(
          (e) => e.moduleName === list.moduleName && list.isActive
        );

        if (index !== -1) {
          const menu: SideBarMenuEntity = allMenus[index];
          authorizedMenus.push({
            ...menu,
            moduleId: list.moduleId,
            subMenu: [],
          });
        }
      }
      // authorizedMenus = authorizedMenus.sort((a, b) => a.moduleName.toLowerCase() > b.moduleName.toLowerCase() ? 1 : -1);
      authorizedMenus = authorizedMenus
        .filter((e) => e.moduleName && e.moduleName.toLowerCase() === "dashboard")
        .concat(
          authorizedMenus
            .filter((e) => e.moduleName && e.moduleName.toLowerCase() !== "dashboard")
            .sort((a, b) =>
              a.moduleName
                .toLowerCase()
                .localeCompare(b.moduleName.toLowerCase())
            )
        );

      for (const item of listActionSubModules) {
        const parentMenuIndex: number = authorizedMenus.findIndex(
          (e) => e.moduleId === item.parentId
        );
        if (parentMenuIndex !== -1) {
          const authorizedParentMenu = authorizedMenus[parentMenuIndex];

          const menuWithSubmenu: SideBarMenuEntity | undefined = allMenus.find(
            (e) => e.moduleName === authorizedParentMenu.moduleName
          );
          if (menuWithSubmenu) {
            const index: number = menuWithSubmenu.subMenu.findIndex(
              (e) => e.moduleName === item.moduleName
            );
            if (index !== -1) {
              (authorizedParentMenu.subMenu as SidebarSubMenuEntity[]).push({
                moduleName: menuWithSubmenu.subMenu[index].moduleName,
                url: menuWithSubmenu.subMenu[index].url,
              });
            }
          }
        }
      }

      setSidebarMenus(authorizedMenus);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    $('[data-bs-toggle="minimize"]').on("click", function () {
      const body = $("body");

      if (body) {
        if (
          body.hasClass("sidebar-toggle-display") ||
          body.hasClass("sidebar-absolute")
        ) {
          body.toggleClass("sidebar-hidden");
        } else {
          body.toggleClass("sidebar-icon-only");
        }
      }
    });
  }, []);

  const [hoveredFlyoutRect, setHoveredFlyoutRect] = useState<{ top: number; height: number } | null>(null);

  /*
    Flyout open/close is intent-based, not instant, because the flyout
    sits well below its ~50px-tall trigger icon (it can run to 9 items /
    ~300px), so reaching a lower item means a diagonal mouse path that
    unavoidably crosses the OTHER icons stacked below the trigger before
    it crosses into the flyout at x=70. Both naive behaviors fail — each
    was reproduced by scripting the exact mouse path:
      - close/switch the instant another icon is entered → the flyout
        closes mid-transit for every item but the first one;
      - keep the old item open when another icon is entered → the old
        submenu never closes, and since all open items share one
        hoveredFlyoutRect it gets repainted at the NEW icon's position
        (Transactions' submenu showing attached to the Waltz Orders
        icon).
    The discriminator between those two situations is the pointer's own
    horizontal direction, sampled from recent mousemove positions over
    the sidebar: a transit into the flyout always travels RIGHT (the
    flyout only exists at x >= the icon strip's right edge), while
    ordinary browsing between icons travels vertically down the strip.
    So: entering a different icon while a submenu flyout is open
    switches IMMEDIATELY when the pointer isn't moving right (no lag,
    no flicker while sweeping the strip), and only defers the switch
    (~300ms grace) when it is. If a deferred pointer reaches the flyout
    in time, that fires mouseenter on the open item's own <li> again
    (the flyout is a DOM child of it, position: fixed or not),
    cancelling the pending switch — transit wins; if it settles on the
    new icon instead, the switch fires. Leaving everything schedules a
    delayed full close the same way. A label-only flyout (no submenu)
    never needs transit, so switching away from one is always immediate.
  */
  const pendingTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const openItemRef = useRef<{ index: number; hasSubMenu: boolean } | null>(null);
  const pointerTrailRef = useRef<{ x: number } | null>(null);

  useEffect(() => {
    return () => {
      if (pendingTimeoutRef.current) clearTimeout(pendingTimeoutRef.current);
    };
  }, []);

  const clearPending = () => {
    if (pendingTimeoutRef.current) {
      clearTimeout(pendingTimeoutRef.current);
      pendingTimeoutRef.current = null;
    }
  };

  const closeAllMenus = () => {
    clearPending();
    setSidebarMenus((prev) => prev.map((menu) => ({ ...menu, isHoverOpen: false, isScrollable: false })));
    setHoveredFlyoutRect(null);
    openItemRef.current = null;
    if (typeof $ !== 'undefined') {
      $('.sidebar .collapse.show').removeClass('show');
    }
  };

  useEffect(() => {
    closeAllMenus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const trackPointer = (e: MouseEvent<HTMLUListElement>) => {
    pointerTrailRef.current = { x: e.clientX };
  };

  /*
    Direction = the enter position minus the pointer's LAST KNOWN
    position, with no freshness window on that last position: a pointer
    that rested on the trigger icon for a while and then flicked hasn't
    produced any recent samples — its stale resting spot is still
    exactly the right origin for the displacement. (An age-filtered
    multi-sample version of this was tried first and broke precisely
    that case: one fresh sample isn't a direction, so the gate failed
    open and the flyout closed mid-flick.) mouseenter fires before the
    mousemove that lands inside the new icon, so e.clientX here is the
    new position while the trail still holds the previous one.
  */
  const isPointerMovingTowardFlyout = (enterX: number): boolean => {
    const last = pointerTrailRef.current;
    return last !== null && enterX - last.x > 2;
  };

  const openOnly = (index: number, rect: { top: number; height: number }, isScrollable: boolean) => {
    setSidebarMenus((prev) => prev.map((menu, i) => (
      i === index
        ? { ...menu, isHoverOpen: true, isScrollable }
        : { ...menu, isHoverOpen: false, isScrollable: false }
    )));
    setHoveredFlyoutRect(rect);
    openItemRef.current = { index, hasSubMenu: !IsNullOrEmptyArray(sidebarMenus[index]?.subMenu) };
  };

  const onMouseEnter = (index: number, e: MouseEvent<HTMLLIElement>) => {
    clearPending();

    // The flyout popup is `position: fixed` (see App.css) so it can
    // escape the sidebar's own scroll clipping — it needs its screen
    // position computed here instead of relying on the icon-row's
    // static in-flow position the way absolute positioning used to.
    const rect = e.currentTarget.getBoundingClientRect();
    const flyoutRect = { top: rect.top, height: rect.height };
    // tight on room below the icon
    const isScrollable = window.innerHeight - e.clientY < 120;

    const open = openItemRef.current;
    const isMouseDevice = typeof window !== 'undefined' && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (isMouseDevice && open && open.index !== index && open.hasSubMenu && isPointerMovingTowardFlyout(e.clientX)) {
      pendingTimeoutRef.current = setTimeout(() => {
        pendingTimeoutRef.current = null;
        openOnly(index, flyoutRect, isScrollable);
      }, 300);
      return;
    }

    openOnly(index, flyoutRect, isScrollable);
  };

  const onMouseLeave = () => {
    clearPending();
    pendingTimeoutRef.current = setTimeout(() => {
      pendingTimeoutRef.current = null;
      setSidebarMenus((prev) => prev.map((menu) => ({ ...menu, isHoverOpen: false, isScrollable: false })));
      setHoveredFlyoutRect(null);
      openItemRef.current = null;
    }, 300);
  };

  return (
    <nav className={`sidebar sidebar-offcanvas`} id="sidebar">
      <ul className="nav" onMouseMove={trackPointer} onTouchStart={() => { pointerTrailRef.current = null; }}
      >
        {sidebarMenus.map((value: SideBarMenuEntity, index: number) => (
          <li
            onMouseEnter={(e) => onMouseEnter(index, e)}
            onMouseLeave={() => onMouseLeave()}
            className={`nav-item ${!value.isHoverOpen ? "" : "hover-open"}`}
            key={index}
            style={value.isHoverOpen && hoveredFlyoutRect ? ({
              '--flyout-top': `${hoveredFlyoutRect.top}px`,
              '--flyout-height': `${hoveredFlyoutRect.height}px`,
            } as CSSProperties) : undefined}
          >
            {IsNullOrEmptyArray(value.subMenu) ? (
              <span
                className="nav-link cursor-pointer"
                onClick={() => {
                  if (['Dispatch Manager WOs', 'Saleperson WOs'].includes(value.moduleName)) {
                    setProductionPlannedStatus('', []);
                  }
                  navigate(value.url)
                }}
              >
                <i className={value.icon}></i>
                <span className="menu-title">
                  {/* {
                    value.moduleName
                  } */}
                  {
                    (value.moduleName === allFeaturedModules.goPro
                      || value.moduleName === allFeaturedModules.goProAssetsModule)
                      ? "Go Pro" :
                      value.moduleName
                  }
                </span>
              </span>
            ) : (
              <>
                <a
                  className="nav-link"
                  data-bs-toggle="collapse"
                  href={"#ui-basic-" + index}
                  aria-expanded="false"
                  aria-controls={"ui-basic-" + index}
                >
                  <i className={value.icon}></i>
                  <span className="menu-title">{value.moduleName}</span>
                  <i className="menu-arrow"></i>
                </a>

                <div className="collapse" id={"ui-basic-" + index} style={{ zIndex: 999 }}>
                  <ul className={`nav flex-column sub-menu mb-2 ${value.isScrollable ? "scrollable" : ""}`}>
                    {value.subMenu.map(
                      (sm: SidebarSubMenuEntity, jIndex: number) => (
                        <li className="nav-item" key={jIndex}>
                          <Link className="nav-link" to={sm.url} onClick={closeAllMenus}>
                            {sm.moduleName}
                          </Link>
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
}

export default SideBar;
